import { FormContent } from 'components/form/Form';
import { useMemo } from 'react';
import { FormConfig, FormField } from 'components/form/FormConfig';
import { LoadingIndicator } from 'components/LoadingIndicator';

export type ECSegmentFormContentProps = {
  useFields: () => {
    loading: boolean;
    fields: FormField[]
  };
};

export const ECSegmentFormContent: React.FC<ECSegmentFormContentProps> = ({
  useFields
}) => {

  const {
    loading,
    fields
  } = useFields();

  const formConfig = useMemo(() => {
    return new FormConfig.Builder().addSection(
      new FormConfig.SectionBuilder(
        fields
      ).build()
    );
  }, [fields]);

  return (
    <>
      {loading && <LoadingIndicator />}
      <FormContent formConfig={formConfig} />
    </>
  );
};
